import fs from 'node:fs';

function getCompileDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始计数，需加1并补0
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
// 添加插件来获取服务器的数据
export default defineNuxtPlugin((nuxtApp) => {
    const filePath = 'build-date-time.json';
    try {
        const fileData = fs.readFileSync(filePath, 'utf-8');
        const { buildDateTime } = JSON.parse(fileData);
        // 将读取到的buildDateTime值设置到运行时配置的public部分，以便传递给客户端
        useRuntimeConfig().public.buildDateTime = buildDateTime;
        console.log('已在服务器端读取BUILD_DATE_TIME文件并设置到运行时配置:', buildDateTime);
    } catch (error) {
        console.error('在服务器端读取BUILD_DATE_TIME文件出错:', error);
    }
    return {};
});
